import compact from 'lodash/compact';
import { ItemLinkProps } from '../../../Components/ItemLinks/ItemLink';
import { generateViewBookingDetailsItemLink } from '../generateViewBookingDetailsItemLink';
import { generateUpdatePaymentMethodItemLink } from '../generateUpdatePaymentMethodItemLink';
import { SelfServiceAPI } from 'types';

export const generateActionItemLinks = (booking: SelfServiceAPI.UpcomingBooking, onTrack: () => void): ItemLinkProps[] => {
  const detailsLink = generateViewBookingDetailsItemLink(booking, onTrack);
  const updatePaymentMethodLink = generateUpdatePaymentMethodItemLink(booking);

  return compact([detailsLink, updatePaymentMethodLink]);
};
